import { useForm } from 'react-hook-form';
import { CustomerType } from 'api';
import { DEFAULT_LANGUAGE } from 'constants/language';
import { DEFAULT_PHONE_NUMBER } from 'constants/phoneNumbers';
export default function useNewCustomerForm() {
  const newCustomerForm = useForm({
    mode: 'onChange',
    defaultValues: {
      customerType: CustomerType.Person,
      email: '',
      phoneNumber: DEFAULT_PHONE_NUMBER,
      organizationName: '',
      organizationNumber: '',
      contactName: '',
      contactEmail: '',
      contactPhoneNumber: '',
      personFirstName: '',
      personLastName: '',
      personNumber: '',
      shippingAddress: {
        addressLine1: '',
        addressLine2: '',
        postalCode: '',
        postalDistrict: '',
        careOfName: '',
        countryCode: DEFAULT_LANGUAGE
      },
      billingAddress: {
        addressLine1: '',
        addressLine2: '',
        postalCode: '',
        postalDistrict: '',
        careOfName: '',
        countryCode: DEFAULT_LANGUAGE
      },
      receiveInvoicesByEmail: false,
      billingEmail: ''
    }
  });
  return newCustomerForm;
}